'use client';

import { cn } from '@workspace/ui/lib/utils';
import { CheckCircle2, CircleAlert, Info, Loader, X } from 'lucide-react';
import { toast, Toaster as Sonner, ToasterProps } from 'sonner';

const toastClassNames = {
  toast: cn(
    // pr-10 keeps text and the action button clear of the close button at the right edge
    'group bg-white shadow-card py-3! pl-4! pr-10! border border-gray-60 rounded-2xl text-purple-350 pointer-events-auto',
    'data-[swipe=move]:transition-none data-[swipe=cancel]:translate-x-0',
    'data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)]',
  ),
  content: 'gap-1.5',
  title: 'text-sm text-current',
  description: 'text-current text-xs leading-5 opacity-90',
  icon: 'text-current',
  closeButton: cn(
    'top-1/2! right-3! left-auto! bg-transparent! shadow-none! border-0! [transform:translateY(-50%)]!',
    'text-gray-30! hover:bg-transparent! hover:text-gray-30! focus:ring-0!',
  ),
  loading: '!bg-white !text-primary-darker !border-transparent',
  success: '!bg-green-50 !text-green-500 !border-transparent',
  error: '!bg-red-50 !text-red-500 !border-transparent',
  warning: '!bg-amber-50 !text-amber-500 !border-transparent',
  info: '!bg-blue-50 !text-blue-500 !border-transparent',
  default: '',
};

const toastIcons = {
  success: <CheckCircle2 className="size-5" strokeWidth={2.2} />,
  error: <CircleAlert className="size-5" strokeWidth={2.2} />,
  warning: <CircleAlert className="size-5" strokeWidth={2.2} />,
  info: <Info className="size-5" strokeWidth={2.2} />,
  loading: <Loader className="size-5 animate-spin" strokeWidth={2.2} />,
  close: <X className="size-4" strokeWidth={2.2} />,
};

const Toaster = ({
  className,
  closeButton,
  icons,
  position: _position,
  richColors: _richColors,
  style,
  toastOptions,
  ...props
}: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      position="bottom-center"
      closeButton={closeButton ?? true}
      icons={{
        ...toastIcons,
        ...icons,
      }}
      toastOptions={{
        ...toastOptions,
        classNames: {
          ...toastClassNames,
          ...toastOptions?.classNames,
        },
      }}
      className={cn('group toaster', className)}
      style={style}
      {...props}
    />
  );
};

export { toast, Toaster };
